import Slider from '../slider';

class BasicSlider extends Slider {
  constructor(element) {
    super(element);

    this.init();
  }

  init() {
    this.initSlider();

    if (this.instance) {
      this.showControls();
    }
  }
}

export default BasicSlider;
